<script>
import chunk from 'lodash-es/chunk'
import elementUiStyles from '@/assets/scss/modules/element-ui.module.scss'

export default {
  functional: true,

  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },

  render(h, { data, props, slots, $style }) {
    return (
      <el-card
        {...data}
        {...{ directives: [{ name: 'loading', value: props.loading }] }}
        element-loading-background="rgba(0, 0, 0, 0.75)"
        element-loading-custom-class={elementUiStyles.loadingMask}
      >
        <h1 style={{ fontSize: '1.125rem', margin: '0 0 1rem' }}>
          สรุปภาพรวมปัจจุบัน
        </h1>
        {slots().default && [
          <mq-layout mq="sm">
            <el-row type="flex" gutter={16} style={{ flexWrap: 'wrap' }}>
              {slots().default.map((vnode, index) => (
                <el-col
                  class={$style.trackerCol}
                  style={{ marginBottom: index < 4 ? '1rem' : null }}
                >
                  {vnode}
                </el-col>
              ))}
            </el-row>
          </mq-layout>,
          <mq-layout mq="md">
            {chunk(slots().default, 2).map((chunkItem, index) => (
              <el-row
                type="flex"
                gutter={16}
                style={{
                  flexWrap: 'wrap',
                  marginBottom: index < 2 ? '1rem' : null
                }}
              >
                {chunkItem.map(vnode => (
                  <el-col sm={12} class={$style.trackerCol}>
                    {vnode}
                  </el-col>
                ))}
              </el-row>
            ))}
          </mq-layout>,
          <mq-layout mq="lg+">
            <el-row type="flex" gutter={16} style={{ flexWrap: 'wrap' }}>
              {slots().default.map(vnode => (
                <el-col
                  span={null}
                  class={$style.trackerCol}
                  style={{ flex: '1', maxWidth: '25%' }}
                >
                  {vnode}
                </el-col>
              ))}
            </el-row>
          </mq-layout>
        ]}
      </el-card>
    )
  }
}
</script>

<style lang="scss" module>
.trackerCol {
  @media (min-width: $--sm) {
    border-left: 1px solid $--border-color-base;
    border-right: 1px solid $--border-color-base;

    &:first-child {
      border-left-color: transparent;
    }

    &:last-child {
      border-right-color: transparent;
    }
  }
}
</style>
